// TemplateRegistry.js - Unified Template System for ALL Document Types

import i18n from '../../../../i18n';
import HeritageInvoicePreview from './HeritageInvoicePreview';

const tplCategory = (key) =>
  i18n.t(`modules.facturation.pages.facturationConfigPage.${key}`);

const resolveTemplateTags = (template) =>
  (template.tags || []).map((tagKey) => tplCategory(tagKey));

/** Single invoice template — Heritage only. */
export const TEMPLATE_REGISTRY = {
  heritage: {
    id: 'heritage',
    name: 'Heritage',
    component: HeritageInvoicePreview,
    category: 'premium',
    description: tplCategory('template_heritage_desc'),
    tags: ['template_tag_classic', 'template_tag_heritage'],
    color: 'amber',
  },
};

export const getTemplateComponent = (templateId = 'heritage') => {
  const template = TEMPLATE_REGISTRY[templateId];
  return template ? template.component : TEMPLATE_REGISTRY.heritage.component;
};

export const getTemplateMetadata = (templateId) => {
  return TEMPLATE_REGISTRY[templateId] || TEMPLATE_REGISTRY.heritage;
};

export const getTemplatesByCategory = (category = 'all') => {
  const templates = Object.values(TEMPLATE_REGISTRY);
  if (category === 'all') return templates;
  return templates.filter((template) => template.category === category);
};

export const searchTemplates = (searchTerm) => {
  if (!searchTerm) return Object.values(TEMPLATE_REGISTRY);
  const lowerSearch = searchTerm.toLowerCase();
  return Object.values(TEMPLATE_REGISTRY).filter(
    (template) =>
      template.name.toLowerCase().includes(lowerSearch) ||
      template.description.toLowerCase().includes(lowerSearch) ||
      resolveTemplateTags(template).some((tag) => tag.toLowerCase().includes(lowerSearch)),
  );
};

export const getTemplateCategories = () => {
  const templates = Object.values(TEMPLATE_REGISTRY);
  const categories = [
    { id: 'all', label: tplCategory('template_category_all'), icon: '📋' },
    { id: 'premium', label: tplCategory('template_category_premium'), icon: '👑' },
  ];
  return categories.map((cat) => ({
    ...cat,
    count: cat.id === 'all' ? templates.length : templates.filter((t) => t.category === cat.id).length,
  }));
};

export default TEMPLATE_REGISTRY;
